'use client';

import { useQuery } from '@tanstack/react-query';
import { useEffect, useSyncExternalStore } from 'react';

import { ProductCard } from '@/entities/product';
import { productCardsQueryOptions } from '@/entities/product/client';
import { cx } from '@/shared/lib/cx';

import {
  getRecentServerSnapshot,
  getRecentSnapshot,
  parseRecent,
  rememberViewed,
  subscribeRecent,
} from '../model/recent-store';
import styles from './recently-viewed.module.scss';

/** "Вы недавно смотрели": products from this browser's history, hidden when there are none. */
export function RecentlyViewed({
  currentSlug,
  className,
}: {
  currentSlug: string;
  className?: string | undefined;
}) {
  const raw = useSyncExternalStore(subscribeRecent, getRecentSnapshot, getRecentServerSnapshot);
  // Remember the current page after it was shown, so it does not appear in its own list.
  useEffect(() => {
    rememberViewed(currentSlug);
  }, [currentSlug]);
  const slugs = parseRecent(raw)
    .filter((slug) => slug !== currentSlug)
    .slice(0, 4);
  const query = useQuery({ ...productCardsQueryOptions(slugs), enabled: slugs.length > 0 });
  const products = query.data ?? [];
  if (!slugs.length || !products.length) return null;
  return (
    <section className={cx(styles.root, className)} aria-labelledby="recent-title">
      <h2 id="recent-title" className={styles.title}>
        Вы недавно смотрели
      </h2>
      <ul className={styles.grid}>
        {products.map((product) => (
          <li key={product.id}>
            <ProductCard product={product} variant="compact" />
          </li>
        ))}
      </ul>
    </section>
  );
}
